import script from "./ChatRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatRoom.vue?vue&type=script&setup=true&lang=js"

import "./ChatRoom.vue?vue&type=style&index=0&id=b3aa73b6&lang=scss"

const __exports__ = script;

export default __exports__